import type { ButtonProps } from './Button';
import s from './ui.module.css';

/** Классы кнопки — и для ссылок, которые выглядят как кнопка (переход на другой сайт, например в Google). */
export function buttonClass({ variant = 'primary', size = 'normal', block = false, className }: Pick<ButtonProps, 'variant' | 'size' | 'block' | 'className'>): string {
  return [s.button, s[variant], size === 'small' ? s.small : size === 'icon' ? s.icon : '', block ? s.block : '', className ?? ''].filter(Boolean).join(' ');
}
